<template>
  <UIPageEmptyState
    icon="wrenchRegular"
    title="EverGPT is under maintenance"
    :description="description"
  />
</template>

<script lang="ts" setup>
import { onUnmounted } from 'vue'

import { setDocumentTitle, usePageTitle } from '@/composables/usePageTitle'
import UIPageEmptyState from '@/views/components/ui/empty_states/UIPageEmptyState.vue'

const description =
  "We're making some improvements and EverGPT is temporarily unavailable. Please check back in a few minutes. If this takes longer than expected, contact our support team."

usePageTitle('Under maintenance')

// Restore the plain app title when maintenance ends — the page the user lands back on
// may not set one of its own (the share/public-GPT pages don't), and a tab still
// reading "Under maintenance" would outlive the outage.
onUnmounted(() => setDocumentTitle())
</script>
